import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgNumericCode = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M13.667 28.333c0-6.914 0-10.37 2.819-12.518s7.356-2.148 16.43-2.148 13.613 0 16.432 2.148c2.819 2.147 2.819 5.604 2.819 12.518v7.334c0 6.913 0 10.37-2.82 12.518-2.818 2.148-7.356 2.148-16.43 2.148s-13.612 0-16.431-2.148c-2.82-2.147-2.82-5.605-2.82-12.518z"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M26.5 32a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0m7.333 0a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M33.833 32a1.833 1.833 0 1 1-3.666 0 1.833 1.833 0 0 1 3.666 0m7.334 0a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M48.71 28.248c0-3.577-.004-6.118-.322-8.046-.312-1.888-.898-2.975-1.873-3.769-.975-.793-2.31-1.27-4.63-1.524-2.368-.259-5.49-.262-9.885-.262s-7.517.003-9.885.262c-2.32.254-3.655.73-4.63 1.524s-1.56 1.881-1.873 3.769c-.318 1.928-.322 4.469-.322 8.046v7.504c0 3.577.004 6.118.322 8.046.312 1.887.898 2.975 1.873 3.768.975.794 2.31 1.27 4.63 1.525 2.368.259 5.49.262 9.885.262s7.517-.003 9.885-.262c2.32-.254 3.655-.73 4.63-1.525.975-.793 1.56-1.88 1.873-3.768.318-1.928.322-4.47.322-8.046zm3.457 7.504c0 3.497.003 6.263-.354 8.422-.363 2.199-1.129 3.978-2.854 5.382-1.724 1.404-3.91 2.027-6.612 2.323-2.653.29-6.05.288-10.347.288s-7.694.002-10.347-.288c-2.702-.296-4.888-.92-6.612-2.323s-2.491-3.183-2.854-5.382c-.357-2.16-.354-4.925-.354-8.422v-7.504c0-3.498-.003-6.263.354-8.422.363-2.199 1.129-3.978 2.854-5.382 1.724-1.404 3.91-2.027 6.612-2.323 2.653-.29 6.05-.288 10.347-.288s7.694-.002 10.347.288c2.701.296 4.888.919 6.612 2.323s2.49 3.183 2.854 5.382c.357 2.16.354 4.924.354 8.422z"
      />
      <path fill="hsl(var(--system-icon-white))" d="M37.5 44.833h-11z" />
    </svg>
  );
};
export default SvgNumericCode;
